import { render } from "./RegistrationListView.vue?vue&type=template&id=3ed4410e"
import script from "./RegistrationListView.vue?vue&type=script&lang=js"
export * from "./RegistrationListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__